import { Component, OnInit, Input } from '@angular/core';
import { EventInfo } from '../../../objects/EventInfo';

@Component({
  selector: 's18-flight-desc',
  templateUrl: './flight-desc.component.html',
  styleUrls: ['./flight-desc.component.scss']
})
export class FlightDescComponent implements OnInit {
  @Input() flight: number
  @Input() eventInfo: EventInfo;

  constructor() { 
    
  }

  ngOnInit() {
    //TODO: if there is an alternate description for the flight, go get it.
  }

  getFlightDesc() {
    switch (+this.flight) {
      case 0:
        return 'NF';
      case 1:
        return 'A';
      case 2:
        return 'B';
      case 3:
        return 'C';
      case 4:
        return 'D';
      case 5:
        return 'E';
      case 6:
        return 'F';
      case 7:
        return 'G';
      case 8:
        return 'H';
    }
  }

}
